<div class="scroll-to-top" [ngStyle]="styling" [ngClass]="{ 'show-scrollTop': windowScrolled }">
    <button mat-icon-button (click)="jumpToTopInstant ? jumpToTop() : scrollBackToTop()">
        <mat-icon class="icon-btn" style="font-weight: bold; transform: rotate(270deg); margin-bottom: 6px"
            >chevron_right</mat-icon
        >
    </button>
</div>
